module.exports = __webpack_public_path__ + "img/pin-angle-fill.5aec9969.svg";